import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from 'ng2-translate';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { ChipsModule } from 'primeng/primeng';

import { TimePickerComponent } from '.';
import { AlertOverviewComponent } from './components/alert-overview/alert-overview.component';
import { AddAlertComponent } from './components/alert-overview/components/add-alert/add-alert.component';
import { DeleteAlertComponent } from './components/alert-overview/components/delete-alert/delete-alert.component';
import { AlertOverviewService } from './components/alert-overview/services/alert-overview.service';
import { ConfirmDeleteComponent } from './components/confirm-delete/confirm-delete.component';
import { ConfirmStopComponent } from './components/confirm-stop/confirm-stop.component';
import { HeaderComponent } from './components/header/header.component';
import { HeaderService } from './components/header/header.service';
import { DialogComponent } from './components/dialog/dialog.component';
import { NotificationComponent } from './components/notification/notification.component';
import { RouteImportComponent } from './components/route-import/route-import.component';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { NotificationClient } from './notifications/notification-client';
import { SharePopupComponent } from './components/share-popup/share-popup.component';
import { StopSharingPopupComponent } from './components/stop-sharing-popup/stop-sharing-popup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    TranslateModule.forRoot(),
    NgxMyDatePickerModule,
    ChipsModule,

  ],
  exports: [
    TimePickerComponent,
    HeaderComponent,
    DialogComponent,
    NotificationComponent,
    RouteImportComponent,
    ConfirmDeleteComponent,
    ConfirmStopComponent,
    AlertOverviewComponent,
    AddAlertComponent,
    TimeFormatPipe,
    LimitToPipe,
    SharePopupComponent,
    StopSharingPopupComponent,
  ],
  providers: [HeaderService, AlertOverviewService, NotificationClient],
  declarations: [
    TimePickerComponent,
    HeaderComponent,
    DialogComponent,
    NotificationComponent,
    RouteImportComponent,
    ConfirmDeleteComponent,
    ConfirmStopComponent,
    TimeFormatPipe,
    LimitToPipe,
    AlertOverviewComponent,
    AddAlertComponent,
    DeleteAlertComponent,
    SharePopupComponent,
    StopSharingPopupComponent,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts